export const ADMIN_USERNAME = 'admin'

export const isAdminUser = (user) =>
  ['admin', 'super_admin'].includes(user?.systemRole) || user?.username === ADMIN_USERNAME
